import styled from 'styled-components';

import { NorlysFont } from '~src/branding';

export const Container = styled.div<{ isMobile?: boolean }>({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '24px',
  minHeight: '340px',
});

export const TextNorlys = styled.div({
  ...NorlysFont.style('heading', 30),
  textAlign: 'center',
  marginBottom: '48px',
  color: 'black',
});
